<template>
  <div>
    <div
      class="text-center text-base relative"
      style="left: 0; right: 0; top: 140px"
      :style="{
        color: !nightMode ? '#fff' : '#000',
        top: graph.name == 'AQI' && !$isMobile() ? '210px' : '170px',
      }"
    >
      <div
        class="w-1/4 mx-auto"
        v-html="
          graph.name === 'noise' ||
          graph.name === 'I_BATT_000' ||
          graph.name === 'PWM_Led_000' ||
          graph.name === 'SoC_000'
            ? formatNamesDonut(graph.name)
            : graph.influxId
        "
      ></div>
      <v-popover
        v-if="$isMobile()"
        offset="16"
        style="position: relative; top: 85px"
      >
        <button class="tooltip-target b3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-info-circle"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            />
          </svg>
        </button>
        <template slot="popover">
          <div>
            <div style="margin: auto; display: inline-block">
              <img
                v-if="
                  graph.name == 'I_BATT_000' ||
                  graph.name == 'PWM_Led_000' ||
                  graph.name == 'SoC_000'
                "
                width="100%"
                :src="
                  require('@/assets/' +
                    $t('dashboard_sensor_' + graph.name) +
                    '.jpg')
                "
              />
              <img
                v-else
                width="100%"
                :src="
                  require('@/assets/' +
                    $t('dashboard_sensor_' + graph.influxId) +
                    '.jpg')
                "
              />
            </div>
          </div>
        </template>
      </v-popover>
      <v-popover
        v-else
        offset="20"
        trigger="hover"
        style="position: relative; top: 85px"
      >
        <button class="tooltip-target b3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-info-circle"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            />
          </svg>
        </button>

        <template slot="popover">
          <div style="width: 50vh; margin: auto">
            <img
              v-if="
                graph.name == 'I_BATT_000' ||
                graph.name == 'PWM_Led_000' ||
                graph.name == 'SoC_000'
              "
              width="100%"
              :src="
                require('@/assets/' +
                  $t('dashboard_sensor_' + graph.name) +
                  '.jpg')
              "
            />
            <img
              v-else
              width="100%"
              :src="
                require('@/assets/' +
                  $t('dashboard_sensor_' + graph.influxId) +
                  '.jpg')
              "
            />
          </div>
        </template>
      </v-popover>
      <div>
        <div
          class="relative"
          style="left: 0; right: 0; top: 0px"
          :style="{ color: !nightMode ? '#fff' : '#000' }"
        >
          ___________
        </div>
        <div
          class="relative text-sm"
          style="left: 0.5%; right: 0; top: 22px"
          :style="{
            color: !nightMode ? '#fff' : '#000',
            left: graph.name == 'AQI' ? '0px' : '',
            top: graph.name == 'AQI' ? '10px' : '0px',
          }"
        >
          {{
            graph.name === "noise" ||
            graph.name === "I_BATT_000" ||
            graph.name === "PWM_Led_000" ||
            graph.name === "SoC_000"
              ? formatFullNames(graph)
              : formatFullNames(graph)
          }}
        </div>
      </div>
    </div>

    <vue-gauge
      :style="'--svg-fill:' + getColorByValue(graph)"
      :class="{ 'custom-gauge-dark': !nightMode, 'custom-gauge': nightMode }"
      :refid="`${graph.influxId}`"
      :options="{
        needleValue: getSensorCenterValue(graph.sensorData[0][1], graph),
        needleColor: !nightMode ? 'white' : 'black',
        arcDelimiters: getArcDelimiters(graph),
        arcPadding: 10,
        rangeLabel: [
          `${getSensorValue(graph, 'min')}`,
          `${getSensorValue(graph, 'max')}`,
        ],
        arcColors: getArcColors(graph),
        centralLabel: getCentralValueRounded(
          graph.sensorData[0][1].toFixed(2),
          graph
        ),
        chartWidth: graph.name == 'AQI' && !$isMobile() ? 370 : 270,
      }"
    >
    </vue-gauge>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  /**
 * Componente de gráfico de donut de DASHBOARD.
 * --------------------------------------------
 *
 * Este componente dibuja un gráfico a partir de la data recibida.
 * Tiene un diseño donde muestra el nombre completo, el nombre técnico y la información sobre los límites de colores(pop-up con imagen)
 *
 */
  props: ["donut", "nightMode"],
  data() {
    return {
      graph: this.donut
    };
  },
  computed: {
    ...mapState("sensors", ["limits"])
  },
  methods: {
    /**
     * Obtiene el valor central del arco a partir de el valor pasado por parámetro y el sensor.
     * @param value
     * @param graph
     */
    getCentralValueRounded(value, graph) {
      if (graph.name == "I_BATT_000") {
        //value = (value / 1000).toFixed(2);
        return `${value}`;
      } else if (graph.name == "PWM_Led_000") {
        //value = (value / 100).toFixed(2);
        return `${value}`;
      } else {
        return `${value}`;
      }
    },
    /**
     * Obtiene el valor a donde tiene que apuntar la flecha del arco a partir de el valor pasado por parámetro y el sensor.
     * @param value
     * @param graph
     */
    getSensorCenterValue(value, graph) {
      let currentValue;
      if (graph.influxId == "T") {
        currentValue = ((value + 50) * 100) / 100;
        return currentValue !== 0 ? currentValue : 0.00001;
      } else if (graph.name == "I_BATT_000") {
        currentValue = value;
        //currentValue = value / 1000;
        currentValue = ((currentValue + 6) * 100) / 12;
        return currentValue !== 0 ? currentValue : 0.00001;
      } else if (graph.name == "PWM_Led_000") {
        return value !== 0 ? value : 0.00001;
          //? ((value / 100) * 100) / this.getSensorValue(graph, "max")
          //: 0.00001;
      } else {
        return value !== 0
          ? (value * 100) / this.getSensorValue(graph, "max")
          : 0.00001;
      }
    },
    /**
     * Obtiene los valores que delimitan el inicio y el fin del arco para cada sensor.
     * @param graph
     */
    getArcDelimiters(graph) {
      let arrBySensor = [];
      this.limits.forEach(sensor => {
        if (graph.name === sensor.name || graph.influxId === sensor.name) {
          if (graph.influxId === "T") {
            arrBySensor = [25, 50, 75, 99.99];
          } else if (graph.name === "I_BATT_000") {
            arrBySensor = [50, 99.99];
          } else {
            let maxSensorVal = sensor.max;
            sensor.limit.forEach(lim => {
              arrBySensor.push(
                this.roundLimitSensor(lim.max, maxSensorVal) === 100
                  ? 99.99
                  : this.roundLimitSensor(lim.max, maxSensorVal)
              );
            });
          }
        }
      });
      return arrBySensor;
    },
    /**
     * redondea el valor del límite máximo ya que no puede llegar a 100 ni a 0.
     * @param limMax
     * @param maxSensorVal
     */
    roundLimitSensor(limMax, maxSensorVal) {
      return limMax !== 0 ? (limMax * 100) / maxSensorVal : 0.00001;
    },
    /**
     * Obtiene el array de colores para cada arco según el sensor pasado por parámetro
     * @param sensor
     */
    getArcColors(sensor) {
      let colorSensor = [];
      this.limits.forEach(sensorLimit => {
        if (
          sensor.influxId === sensorLimit.name ||
          sensor.name === sensorLimit.name
        )
          sensorLimit.limit.forEach(lim => {
            colorSensor.push(lim.color);
          });
      });
      return colorSensor;
    },
    /**
     * Retorna el color actual calculado a partir de el valor del sensor
     * pintará el label central y la flecha
     * @param sensor
     */
    getColorByValue(sensor) {
      let currentColor = "#fff";
      let currentValue = this.getCentralValueRounded(
        sensor.sensorData[0][1].toFixed(2),
        sensor
      );
      if (
        sensor.name === "PWM_Led_000" ||
        sensor.name === "I_BATT_000" ||
        sensor.name === "SoC_000"
      ) {
        if (
          sensor.name === "PWM_Led_000" ||
          sensor.name === "I_BATT_000" ||
          sensor.name === "SoC_000"
        ) {
          this.limits.forEach(sensorLimit => {
            sensorLimit.limit.forEach(limit => {
              if (sensor.name === sensorLimit.name) {
                if (currentValue >= limit.min && currentValue < limit.max)
                  currentColor = limit.color;
              }
            });
          });
        }
      } else {
        this.limits.forEach(sensorLimit => {
          if (sensor.influxId === sensorLimit.name) {
            sensorLimit.limit.forEach(limit => {
              if (currentValue >= limit.min && currentValue < limit.max)
                currentColor = limit.color;
            });
          }
        });
      }
      return currentColor;
    },
    /**
     * Retorna el valor máximo y mínimo de cada sensor para calcular(no es para rellenar los labels delimitadores del arco de los lados)
     * @param sensor
     * @param valType
     */
    getSensorValue(sensor, valType) {
      let value;
      if (
        sensor.name === "PWM_Led_000" ||
        sensor.name === "I_BATT_000" ||
        sensor.name === "SoC_000"
      ) {
        if (valType === "max") {
          this.limits.forEach(sensorLimit => {
            if (sensor.name === sensorLimit.name) {
              value = sensorLimit.max;
            }
          });
        } else if (valType === "min") {
          this.limits.forEach(sensorLimit => {
            if (sensor.name === sensorLimit.name) {
              value = sensorLimit.min;
            }
          });
        }
      } else {
        if (valType === "max") {
          this.limits.forEach(sensorLimit => {
            if (sensor.influxId === sensorLimit.name) {
              value = sensorLimit.max;
            }
          });
        } else if (valType === "min") {
          this.limits.forEach(sensorLimit => {
            if (sensor.influxId === sensorLimit.name) {
              value = sensorLimit.min;
            }
          });
        }
      }
      return value;
    },
    /**
     * Retorna el nombre completo(descripción) de los sensores pasando como parámetro el influxId
     * @param graph
     */
    formatFullNames(graph) {
      switch (graph.influxId) {
        case "noise":
          return this.$i18n.t("dashboard_sensor_noise2");
        case "PM2_5":
          return this.$i18n.t("dashboard_s_pm25");
        case "PM10":
          return this.$i18n.t("dashboard_s_pm10");
        case "NO2":
          return this.$i18n.t("dashboard_s_no2");
        case "SO2":
          return this.$i18n.t("dashboard_s_so2");
        case "O3":
          return this.$i18n.t("dashboard_s_o3");
        case "CO2":
          return this.$i18n.t("dashboard_s_co2");
        case "T":
          return this.$i18n.t("dashboard_s_t");
        case "RH":
          return this.$i18n.t("dashboard_s_rh");
        case "AQI":
          return this.$i18n.t("dashboard_s_aqi");
      }
      switch (graph.name) {
        case "I_BATT_000":
          return this.$i18n.t("dashboard_sensor_current_battery");
        case "PWM_Led_000":
          return this.$i18n.t("dashboard_sensor_led");
        case "SoC_000":
          return this.$i18n.t("dashboard_sensor_battery");
      }
    },
    /**
     * Retorna el nombre completo(descripción) de los sensores de control de energía pasando como parámetro el nombre
     * @param name
     */
    formatNamesDonut(name) {
      switch (name) {
        case "noise":
          return this.$i18n.t("dashboard_donut_sensor_noise2");
        case "I_BATT_000":
          return this.$i18n.t("dashboard_donut_sensor_current_battery");
        case "PWM_Led_000":
          return this.$i18n.t("dashboard_donut_sensor_led");
        case "SoC_000":
          return this.$i18n.t("dashboard_donut_sensor_battery");
      }
    }
  },
  watch: {
    /**
     * Detecta sí ha habido un cambio en el modo oscuro para recargar la app
     */
    nightMode: function() {
      window.location.reload();
    }
  }
};
</script>
<style>
svg > path:nth-last-child(5) {
  fill: var(--svg-fill);
  stroke: var(--svg-fill);
}
svg > text:nth-last-child(1) {
  fill: var(--svg-fill);
  -webkit-transform: translate(0, 5%);
  -ms-transform: translate(0, 5%);
  transform: translate(0, 5%);
}
</style>